<template>
  <div class="duration-filter" :class="{ mobile: $mq === 'mobile' }">
    <div
      class="duration-filter-item"
      :class="{ active: item.value === activeDuration }"
      v-for="(item, i) in durations"
      :key="`duration-item-${i}`"
      @click="changeDuration(item)"
    >
      {{ item.text }}
    </div>
    <date-picker
      :max-date="new Date()"
      @change="change"
      range
      :datesProp="rangeValue"
    />
  </div>
</template>

<script>
import DatePicker from '../DatePicker'
import moment from 'moment'
export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      activeDuration: 'week',
      rangeValue: null,
      isRangeUpdateFromButton: false,
    }
  },
  computed: {
    durations() {
      return [
        { text: this.$t('common.day_1'), value: '1_day' },
        { text: this.$t('common.week_1'), value: 'week' },
        { text: this.$t('common.month_1'), value: 'month' },
        { text: this.$t('common.month_3'), value: '3_months' },
      ]
    }
  },
  created() {
    this.isRangeUpdateFromButton = true
    this.rangeValue = {
      start: moment().subtract(1, 'week').toDate(),
      end: new Date(),
    }
    // Emit initial dateFilterChange for table data loading
    this.$emit('dateFilterChange', this.rangeValue)
    
    // Ensure the initial duration matches the initial range
    this.$nextTick(() => {
      this.isRangeUpdateFromButton = false
    })
  },
  methods: {
    change(val) {
      if (val && val.start && val.end) {
        // Skip finding matching duration if range was updated from button click
        if (!this.isRangeUpdateFromButton) {
          this.activeDuration = this.findMatchingDuration(val.start, val.end)
        } else {
          // Reset flag after programmatic update
          this.isRangeUpdateFromButton = false
        }
        console.log("Emit date filter change", val)
        this.$emit('dateFilterChange', val)
      }
    },
    findMatchingDuration(start, end) {
      const diffInDays = moment(end).diff(moment(start), 'days')
      
      // Check if the difference matches any predefined duration
      if (diffInDays === 1) {
        return '1_day'
      } else if (diffInDays === 7) {
        return 'week'
      } else if (diffInDays >= 28 && diffInDays <= 31) {
        return 'month'
      } else if (diffInDays >= 89 && diffInDays <= 92) {
        return '3_months'
      }
      
      // If no match found, return empty string to deactivate all buttons
      return ''
    },
    changeDuration(item) {
      if (item) {
        this.activeDuration = item.value
        let end = moment().toDate()
        let start
        switch (item.value) {
          case '1_day':
            start = moment().subtract(1, 'day').toDate()
            break
          case 'week':
            start = moment().subtract(1, 'week').toDate()
            break
          case 'month':
            start = moment().subtract(1, 'month').toDate()
            break
          case '3_months':
            start = moment().subtract(3, 'months').toDate()
            break
          default:
            start = moment().subtract(1, 'day').toDate()
            break
        }
        this.isRangeUpdateFromButton = true
        this.rangeValue = { start, end }
        this.$emit('dateFilterChange', this.rangeValue)
      }
    },
  },
}
</script>

<style lang="scss">
@import './DurationFilter.scss';
</style>
